<script setup>
import { ref } from 'vue';

const solutions = ref([
  {
    key: 'fuelWatch',
    isOpen: false,
  },
  {
    key: 'habitSafe',
    isOpen: false,
  },
  {
    key: 'fleetSight',
    isOpen: false,
  },
]);

const toggleAccordion = (index) => {
  solutions.value.forEach((solution, i) => {
    if (i === index) {
      solution.isOpen = !solution.isOpen;
    } else {
      solution.isOpen = false; // Optional: close others
    }
  });
};
</script>

<template>
  <section class="section-container solutions-bg">
    <h2 class="section-title">{{ $t('home-page.solutions.title') }}</h2>
    <div class="solutions-wrapper">
      <div
        v-for="(solution, index) in solutions"
        :key="solution.key"
        class="accordion-item"
        data-aos="fade-up"
        :data-aos-delay="index * 100"
      >
        <button
          class="accordion-header"
          @click="toggleAccordion(index)"
          :aria-expanded="solution.isOpen"
        >
          <span>{{ $t(`home-page.solutions.${solution.key}.title`) }}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            class="accordion-icon"
            :class="{ 'rotate-180': solution.isOpen }"
          >
            <path
              fill-rule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
        <transition name="fade-height">
          <div v-if="solution.isOpen" class="accordion-content">
            <p class="description">
              {{ $t(`home-page.solutions.${solution.key}.description`) }}
            </p>
            <ul>
              <li v-if="solution.key === 'fuelWatch'" v-for="i in 4" :key="i">
                {{ $t(`home-page.solutions.fuelWatch.advantages[${i - 1}]`) }}
              </li>
              <li v-if="solution.key === 'habitSafe'" v-for="i in 5" :key="i">
                {{ $t(`home-page.solutions.habitSafe.objectives[${i - 1}]`) }}
              </li>
              <li v-if="solution.key === 'fleetSight'" v-for="i in 3" :key="i">
                {{ $t(`home-page.solutions.fleetSight.features[${i - 1}]`) }}
              </li>
            </ul>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<style scoped>
.solutions-bg {
  background-color: #f8f9fa;
}
.solutions-wrapper {
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.accordion-item {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
}
.accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1.5rem;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  font-size: 1.2rem;
  font-weight: 600;
  color: #0A2D61;
}
.accordion-icon {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
}
.accordion-icon.rotate-180 {
  transform: rotate(180deg);
}
.accordion-content {
  padding: 0 1.5rem 1.5rem 1.5rem;
  color: #555;
  line-height: 1.7;
}
.accordion-content ul {
  padding-left: 20px;
  margin-top: 1rem;
  text-align: left;
}
.accordion-content li {
  margin-bottom: 0.5rem
}
.fade-height-enter-active,
.fade-height-leave-active {
  transition: all 0.3s ease;
  max-height: 500px;
}
.fade-height-enter-from,
.fade-height-leave-to {
  opacity: 0;
  max-height: 0;
  transform: translateY(-10px);
}
</style>
